import React, {useEffect, useState} from 'react';
import {Tab, Tabs} from "@material-ui/core";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import makeStyles from "@material-ui/styles/makeStyles";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../Utils/lib";
import {generateBorder} from "../../../Utils/generateStyles";
import clsx from "clsx";
import TabContent from "./TabContent";
import Badge from "@material-ui/core/Badge";

const useStyles = makeStyles(() => ({
    tabWrapper: {
        alignItems: props => props.alignTabText || 'center',
    },
    selectedTab: ({selectedTabStyles}) => ({
        backgroundColor: selectedTabStyles.background,
        color: `${selectedTabStyles.color} !important`,
        ...selectedTabStyles.selectedBorderObject,
        borderColor: selectedTabStyles.borderColor,
        borderRadius: selectedTabStyles.borderRadius,
        borderStyle: selectedTabStyles.borderStyle,
    }),
    tabRoot: ({tabStyles}) => ({
        color: tabStyles.color,
        ...tabStyles.tabBorderObject,
        borderColor: tabStyles.borderColor,
        borderRadius: tabStyles.borderRadius,
        borderStyle: tabStyles.borderStyle,
        margin: tabStyles.margin,
    })
}))
const TabsScreenComponent = (props) => {
    const {element: {children = [], styles = [{}], properties = {}} = {}, containerArrayPath} = props;
    const [activeTab, setActiveTab] = useState(0);
    const [tabs, setTabs] = useState([])
    const {userLanguage} = useSelector(state => state.app);
    const paramStyles = styles[0] || {};
    const tabStyles = styles[1] || {selectedTabStyles: {}};
    const tabBorderObject = generateBorder(tabStyles)
    const selectedBorderObject = generateBorder(tabStyles.selectedTabStyles, true)
    const {variant} = properties;
    const classes = useStyles({
        alignTabText: paramStyles.alignTabText,
        selectedTabStyles: {...tabStyles.selectedTabStyles, selectedBorderObject},
        tabStyles: {...tabStyles, tabBorderObject}
    })

    useEffect(() => {
        setTabs(Array.from(children, () => ({
            errCount: 0
        })))
    }, [children.length]);


    function onTabClick(activeTab) {
        setActiveTab(activeTab)
    }

    const onKeyDownButton = (event) => {
        const {history} = props;
        if (event.keyCode === 27) {
            history.goBack();
        }
    };

    function setErroredTab(tabIndex, errCount) {
        setTabs(prev =>
            prev.map((item, index) => (tabIndex === index ? {...item, errCount} : item))
        )
    }

    return (
        <div style={{
            width: paramStyles.width,
            height: paramStyles.height,
            margin: paramStyles.margin,
            padding: 2,
            display: paramStyles.orientation === 'vertical' ? 'flex' : 'block'
        }}
             className={clsx(paramStyles.className, 'sb-tabs-container')}
        >
            <div style={{
                background: paramStyles.background,
            }}>
                <Tabs
                    value={activeTab}
                    onChange={(event, activeTab) => onTabClick(activeTab)}
                    indicatorColor={paramStyles.indicatorColor}
                    orientation={paramStyles.orientation || 'horizontal'}
                    style={{minHeight: 30}}
                    variant={variant ? variant : "standard"}
                    TabIndicatorProps={{style: {background: tabStyles.selectedTabStyles.indicatorColor}}}
                >
                    {children.map((element, index) => {
                        const multiLanguageLabel = multiLanguageValue(element.properties.label, userLanguage)
                        const styles = element.styles ? element.styles[0] : {};
                        let errorsCount = tabs[index]?.errCount;
                        return (
                            <Tab
                                textColor={styles.color}
                                key={index}
                                id={element.tabId}
                                label={<div style={{
                                    position: 'relative',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    {multiLanguageLabel}
                                    <div>
                                        {(errorsCount > 0) && (
                                            <Badge
                                                style={{width: 25}}
                                                color={'error'} badgeContent={tabs[index]?.errCount}/>
                                        )}
                                    </div>
                                </div>
                                }
                                classes={{
                                    wrapper: classes.tabWrapper,
                                    selected: classes.selectedTab,
                                    root: classes.tabRoot
                                }}
                                onKeyDown={(event) => onKeyDownButton(event)}
                                style={{minHeight: 30, ...styles}}
                            />
                        )
                    })}
                </Tabs>
            </div>
            {children.map((element, index) => {
                const {properties: {renderWhenVisible}} = element;
                const isVisible = activeTab === index;
                return (
                    <div key={index}
                         style={{
                             display: activeTab === index ? 'block' : 'none',
                             overflow: 'auto',
                             padding: 5,
                             width: paramStyles.orientation === 'vertical' ? '100%' : 'auto',
                             height: paramStyles.orientation === 'vertical' ? '100%' : 'calc(100% - 34px)'
                         }}
                    >
                        <TabContent
                            children={element.children}
                            index={index}
                            activeTab={activeTab}
                            containerArrayPath={containerArrayPath}
                            setErroredTab={setErroredTab}
                            renderWhenVisible={renderWhenVisible}
                            isVisible={isVisible}
                        />
                    </div>
                )
            })}
        </div>
    );
};

export default JsonScreenHoc(TabsScreenComponent);
